import store from '@/store/index'
import { setTitle, processType } from '@/utils/common'
import util from '@/utils/util'

// 全局前置钩子函数
export function routerBeforeEachFunc (to, from, next) {
	if (to.query.alipay || util.getSess('aLiPay')) {
		util.setSess('aLiPay', true)
		processType.aLiPay = true
	}
	store.commit('updateLoadingStatus', {isLoading: true})
	if (to.meta.title) {
		setTitle(to.meta.title)
	}
	next()
}

// 全局后置钩子函数
export function routerAfterEachFunc (to, from) {
	store.commit('updateLoadingStatus', {isLoading: false})
}


// WEBPACK FOOTER //
// ./src/config/interceptors/router.js